export default "__VITE_ASSET__DomNBV4B__"